module.exports = __webpack_public_path__ + "media/images/mosaic-1295706ab71ed35a010c320de62daf74.svg";